export function isIE() {
    return Boolean(document.documentMode);
}
//# sourceMappingURL=browserDetection.js.map